export const SET_CITIES = 'setCities'
